export class ApiResponseError extends Error {
    constructor(response, request) {
        super(response);
        this.message = `${response._data.message}`;
        if (process.server) { console.log(this.message); }
    }
}